"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var TimelineFilterGroup = function TimelineFilterGroup(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      groupType = _ref.groupType,
      handleGroupClick = _ref.handleGroupClick,
      indeterminate = _ref.indeterminate,
      rightPad = _ref.rightPad;
  return _react.default.createElement("div", {
    className: "p-right-" + rightPad + " p-bottom-3"
  }, _react.default.createElement(_UICheckbox.default, {
    checked: checked,
    className: "p-left-1 p-top-6",
    indeterminate: indeterminate,
    onChange: handleGroupClick
  }, _react.default.createElement("h6", {
    className: "small-caps"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "profileContentTimeline.eventGroups." + groupType
  }))), children);
};

TimelineFilterGroup.propTypes = {
  children: _propTypes.default.node,
  groupType: _propTypes.default.string.isRequired,
  rightPad: _propTypes.default.number.isRequired,
  handleGroupClick: _propTypes.default.func,
  checked: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool
};
var _default = TimelineFilterGroup;
exports.default = _default;
module.exports = exports.default;